var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1296 5.0583C7.39678 5.0583 5.19248 7.2626 5.19248 9.99541C5.19248 12.7282 7.39678 14.9325 10.1296 14.9325C12.8624 14.9325 15.0667 12.7282 15.0667 9.99541C15.0667 7.2626 12.8624 5.0583 10.1296 5.0583ZM10.1296 13.2052C8.36357 13.2052 6.91982 11.7657 6.91982 9.99541C6.91982 8.2251 8.35928 6.78564 10.1296 6.78564C11.8999 6.78564 13.3394 8.2251 13.3394 9.99541C13.3394 11.7657 11.8956 13.2052 10.1296 13.2052V13.2052ZM16.4202 4.85635C16.4202 5.49658 15.9046 6.00791 15.2687 6.00791C14.6284 6.00791 14.1171 5.49229 14.1171 4.85635C14.1171 4.22041 14.6327 3.70478 15.2687 3.70478C15.9046 3.70478 16.4202 4.22041 16.4202 4.85635ZM19.6901 6.0251C19.6171 4.48252 19.2647 3.11611 18.1347 1.99033C17.0089 0.864551 15.6425 0.512207 14.0999 0.434863C12.5101 0.344629 7.74482 0.344629 6.15498 0.434863C4.6167 0.50791 3.25029 0.860254 2.12021 1.98604C0.990137 3.11182 0.64209 4.47822 0.564746 6.0208C0.474512 7.61064 0.474512 12.3759 0.564746 13.9657C0.637793 15.5083 0.990137 16.8747 2.12021 18.0005C3.25029 19.1263 4.6124 19.4786 6.15498 19.556C7.74482 19.6462 12.5101 19.6462 14.0999 19.556C15.6425 19.4829 17.0089 19.1306 18.1347 18.0005C19.2604 16.8747 19.6128 15.5083 19.6901 13.9657C19.7804 12.3759 19.7804 7.61494 19.6901 6.0251V6.0251ZM17.6362 15.6716C17.3011 16.5138 16.6522 17.1626 15.8058 17.5021C14.5382 18.0048 11.5304 17.8888 10.1296 17.8888C8.72881 17.8888 5.7167 18.0005 4.45342 17.5021C3.61123 17.1669 2.9624 16.5181 2.62295 15.6716C2.12021 14.404 2.23623 11.3962 2.23623 9.99541C2.23623 8.59463 2.12451 5.58252 2.62295 4.31924C2.95811 3.47705 3.60693 2.82822 4.45342 2.48877C5.721 1.98604 8.72881 2.10205 10.1296 2.10205C11.5304 2.10205 14.5425 1.99033 15.8058 2.48877C16.648 2.82393 17.2968 3.47275 17.6362 4.31924C18.139 5.58682 18.0229 8.59463 18.0229 9.99541C18.0229 11.3962 18.139 14.4083 17.6362 15.6716Z",
    fill: "url(#paint0_linear_561_727)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_561_727",
    x1: 19.7578,
    y1: 0.367188,
    x2: 0.49707,
    y2: 0.367188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8468BF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.94668fc5ec19339f995fae70244557ec.svg";
export { ForwardRef as ReactComponent };